import Joi from "joi";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";
import FormValidationResult from "../../../../../../common/utils/validation/types/form-validation-result";
import userFormValidationService from "../../../../../../shared/user/user.validation.service";

const validateCargoCompany = (
  cargoCompanyUuid: string
): FormValidationResult => {
  const validationSchema = Joi.string().min(1).required();

  return formValidationService.validate(cargoCompanyUuid, validationSchema);
};

const cargoOfficerAddByRailyFormValidationService = {
  validateCargoCompany,
  validateUsername: userFormValidationService.validateUsername,
  validatePassword: userFormValidationService.validatePassword,
  validatePasswordRepeat: userFormValidationService.validatePasswordRepeat,
  validateFirstName: userFormValidationService.validateFirstName,
  validateLastName: userFormValidationService.validateLastName,
  validatePhoneNumber: userFormValidationService.validateMobile,
  validateAlternativePhoneNumber:
    userFormValidationService.validateAlternativeMobile,
  validateEmail: userFormValidationService.validateEmail,
};

export default cargoOfficerAddByRailyFormValidationService;
